export interface FareRule {
  id: number;
  title: string;
  text: string;
  textGolPremium?: string;
}

export const FareRulesFirst: FareRule[] = [
  {
    id: 1,
    title: "BAGAGGE.title",
    text: "BAGAGGE.text",
    textGolPremium: "BAGAGGE.textGolPremium",
  },
  {
    id: 2,
    title: "HAND_BAGAGGE.title",
    text: "HAND_BAGAGGE.text",
  },
  {
    id: 3,
    title: "DOCUMENT.title",
    text: "DOCUMENT.text",
  },
  {
    id: 4,
    title: "RETURN_POINTS.title",
    text: "RETURN_POINTS.text",
  },
  {
    id: 5,
    title: "NO_SHOW.title",
    text: "NO_SHOW.text",
  },
];

export const FareRulesLast = [
  {
    id: 1,
    title: "MARK_SEAT.title",
    text: "MARK_SEAT.text",
  },
  {
    id: 2,
    title: "CANCEL_REFUND.title",
    text: "CANCEL_REFUND.text",
  },
  {
    id: 3,
    title: "TRANSFER_TICKET.title",
    text: "TRANSFER_TICKET.text",
  },
  {
    id: 4,
    title: "CREDIT_VOEBIZ.title",
    text: "CREDIT_VOEBIZ.text",
  },
];
